import {
  CERTIFICATES_TYPES_ARRAY,
  ENUM_CERTIFICATES_TYPES,
} from '../../../../interaces/certificates_types.interface';
import { FaDownload } from 'react-icons/fa';
import { useAuth } from '../../../../context/AuthContext';
import { ENUM_PERMISSIONS } from '../../../../interaces/enums/enums.interface';
import styles from "../../styles/SummaryCard.module.css"
const formatBirthDate = (birthDate) => {
  if (!birthDate) return '-----';

  const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDate);
  const parsedDate = dateOnlyMatch
    ? new Date(
        Number(dateOnlyMatch[1]),
        Number(dateOnlyMatch[2]) - 1,
        Number(dateOnlyMatch[3])
      )
    : new Date(birthDate);

  if (Number.isNaN(parsedDate.getTime())) return '-----';
  return parsedDate.toLocaleDateString('es-MX');
};

function SummaryCard({
  type,
  data,
  error,
  searchParams,
  hideDownload = false,
  dataInformation = null,
  onEmit = null,
  onDownload = null,
}) {
  const { hasPrivilege } = useAuth();

 return (
  <div className={styles.summaryCard}>
    <div className={styles.summaryCardHeader}>
      {dataInformation?.title}
    </div>

    <div className={styles.summaryCardNameSection}>
      <h3 className={styles.summaryCardName}>
        {type === ENUM_CERTIFICATES_TYPES.properties
          ? data
            ? data.fullName
            : error
              ? 'Error'
              : 'Sin consulta'
          : type === ENUM_CERTIFICATES_TYPES.business
            ? data
              ? data.owner
              : error
                ? 'Error'
                : 'Sin consulta'
            : data
              ? data.fullName
              : error
                ? 'Error'
                : 'Sin consulta'}
      </h3>

      <small className={styles.summaryCardNameSubtitle}>
        Datos verificados
      </small>
    </div>

    <div className={styles.summaryCardBody}>
      {type === ENUM_CERTIFICATES_TYPES.properties ? (
        <div className={styles.summaryCardRow}>
          <div className={styles.summaryCardCol}>
            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Clave Catastral
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.cadastralKey : '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Folio Registral
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.registryFolio : '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Propietario
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.owner : '-----'}
              </strong>
            </div>
          </div>

          <div className={styles.summaryCardCol}>
            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Municipio
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.municipality : '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Uso de Suelo
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.landUse : '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Estatus
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.status : '-----'}
              </strong>
            </div>
          </div>
        </div>
      ) : type === ENUM_CERTIFICATES_TYPES.business ? (
        <div className={styles.summaryCardRow}>
          <div className={styles.summaryCardCol}>
            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Razón Social
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.businessActivity : '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                RFC
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.rfc : '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <strong className={styles.summaryCardValue}>
                {data ? data.commercialFolio : '-----'}
              </strong>
              <span className={styles.summaryCardLabel}>
                Folio Mercantil
              </span>
            </div>
          </div>

          <div className={styles.summaryCardCol}>
            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Representante Legal
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.legalRepresentative : '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Municipio
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.municipality : '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Estatus
              </span>
              <strong className={styles.summaryCardValue}>
                {data ? data.status : '-----'}
              </strong>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.summaryCardRow}>
          <div className={styles.summaryCardCol}>
            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                CURP
              </span>
              <strong className={styles.summaryCardValue}>
                {data?.curp || '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                RFC
              </span>
              <strong className={styles.summaryCardValue}>
                {data?.rfc || '-----'}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Sexo
              </span>
              <strong className={styles.summaryCardValue}>
                {data?.gender || '-----'}
              </strong>
            </div>
          </div>

          <div className={styles.summaryCardCol}>
            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Fecha de Nacimiento
              </span>
              <strong className={styles.summaryCardValue}>
                {formatBirthDate(data?.birthDate)}
              </strong>
            </div>

            <div className={styles.summaryCardField}>
              <span className={styles.summaryCardLabel}>
                Estado
              </span>
              <strong className={styles.summaryCardValue}>
                {data?.state || '-----'}
              </strong>
            </div>
          </div>
        </div>
      )}
    </div>

    {hasPrivilege(ENUM_PERMISSIONS.MOD_EMISSION_CREATE) && (
      <div className={styles.summaryCardFooter}>
        <button
          className={styles.summaryCardBtnEmit}
          onClick={onEmit}
        >
          Emitir Certificado
        </button>
      </div>
    )}

    {!hideDownload && (
      <div className={styles.summaryCardFooterDownload}>
        <button
          className={styles.summaryCardBtnDownload}
          onClick={onDownload}
          disabled={!data}
        >
          <FaDownload />
          Descargar
        </button>
      </div>
    )}
  </div>
);
}

export default SummaryCard;
